import axios from 'axios'
import { URLS } from '../factories'
import { ApplicationModule, AuthModule } from '../store'
import AgentApplication from '../types/auth/agent-application'

export default {
  async loadAgent () {
    if (!AuthModule.isProduction) {
      return
    }

    const allstarsApiUrl = AuthModule.isProduction ? URLS.production.allstarsApiUrl : URLS.replica.allstarsApiUrl

    const tokenString = 'Bearer ' + AuthModule.token!.authenticationToken
    const headersObj = { Authorization: tokenString }

    const agentApplication = {} as AgentApplication

    agentApplication.agentPublicId = ApplicationModule.utmParameters!.agentPublicId!
    agentApplication.applicationGuid = ApplicationModule.GUID

    await axios({
      method: 'POST',
      url: allstarsApiUrl + '/application',
      headers: headersObj,
      data: agentApplication
    }).catch(error => {
      window.console.error(error.message)
    })
  }
}
